<template>
    <top-menu :captain="captain"
              :tacticCurrent="tacticCurrent"
              @selectItem="selectTactic"
    ></top-menu>
    <message-show :infos="infos"
                  :captain="captain"
                  :myStatus="myStatus"
    ></message-show>
    <foot-menu :infos="infos"
               :tacticCurrent="tacticCurrent"
               :captain="captain"
               :myStatus="myStatus"
    ></foot-menu>
    <top-tips ref="topTips"></top-tips>
</template>

<script>
    import FootMenu from '@/components/foot-menu/foot-menu';
    import MessageShow from '@/components/message-show/message-show';
    import TopMenu from '@/components/top-menu/top-menu';
    import TopTips from '@/components/top-tips/top-tips';

    import {checkLogin, initStatusAndCaptain} from '@/api/post.js';
    import { getmain } from "@/api/get";
    import {STATUS} from "@/common/const";

    let timer = null;

    export default {
        name: 'App',
        created() {
            this.checkUserLogin();
            this.getMain();
            this.initStatus();
        },
        data() {
            return {
                // 成员聊天等信息
                infos: [],
                // 选择的战术
                tacticCurrent: 0,
                // 谁是队长
                captain: 'nobody',
                myStatus: STATUS.outline
            }
        },
        methods: {
            selectTactic(index) {
                this.tacticCurrent = index;
            },
            async checkUserLogin() {
                const isLogin = await checkLogin();
                if (!isLogin) {
                    window.alert('抱歉，请先登录');
                    window.location.href = 'login.html';
                }
            },
            getMain() {
                const username = window.setting.userInfo.username;
                const TIME = window.setting.getmainTime;
                // 只有请求成功的时候才会再去发送请求
                timer = setTimeout(async () => {
                    const main = await getmain(username);

                    if (main.infos && main.infos.length >= 0) {
                        clearInterval(timer);
                        this.captain = main.captain;
                        this.myStatus = main.mystatus;

                        this.setInfos(main.infos);

                        this.tacticCurrent = parseInt(main.tactic_current);

                        this.getMain();
                    }
                    // console.log(main)

                }, TIME);
            },
            async initStatus() {
                const username = window.setting.userInfo.username;
                const status = await initStatusAndCaptain(username);
                // 更新我的在线状态
                this.myStatus = status.mystatus;
            },
            setInfos(arr) {
                let aArr = [];
                let bArr = [];
                arr.forEach(item => {
                    if (item.username == this.captain) {
                        aArr.push(item);
                    } else {
                        bArr.push(item);
                    }
                });
                this.infos = aArr.concat(bArr);
            }
        }
        ,
        watch: {
            captain(newval, oldval) {
                // console.log(newval, oldval)
                if (newval != oldval) {
                    const myname = window.setting.userInfo.username;
                    if (newval == myname) {
                        this.$refs.topTips.show('您已经被选为本局的队长');
                    }
                }
            }
        },
        components: {
            FootMenu,
            MessageShow,
            TopMenu,
            TopTips
        }
    }
</script>

<style>
    #app {
        background: #f4f5f5;
        min-height: 100vh;
        max-width: 640px;
        margin: 0 auto;
    }

    .top-menu {
        display: flex;

    }
</style>
